(() => {
  const initHero = (scope = document) => {
    scope.querySelectorAll('[data-fe-home-hero]').forEach((root) => {
      if (root.dataset.carouselReady === 'true') return;
      const slides = Array.from(root.querySelectorAll('[data-fe-hero-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-fe-hero-dot]'));
      const model = root.querySelector('[data-fe-hero-model]');
      const count = root.querySelector('[data-fe-hero-current]');
      if (slides.length < 2 || !dots.length) return;
      root.dataset.carouselReady = 'true';
      let active = 0;
      let timer;
      let held = false;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const selected = i === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', String(!selected));
        });
        dots.forEach((dot, i) => {
          const selected = i === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-pressed', String(selected));
        });
        if (model) model.textContent = slides[active].dataset.productName || '';
        if (count) count.textContent = String(active + 1).padStart(2, '0');
      };
      const stop = () => { window.clearInterval(timer); timer = undefined; };
      const start = () => {
        stop();
        if (!held && !reduced) timer = window.setInterval(() => show(active + 1), 6500);
      };
      root.querySelector('[data-fe-hero-prev]')?.addEventListener('click', () => { show(active - 1); start(); });
      root.querySelector('[data-fe-hero-next]')?.addEventListener('click', () => { show(active + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.feHeroDot)); start(); }));
      root.addEventListener('pointerenter', () => { held = true; stop(); });
      root.addEventListener('pointerleave', () => { held = false; start(); });
      root.addEventListener('focusin', () => { held = true; stop(); });
      root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) { held = false; start(); } });
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { show(active - 1); start(); }
        if (event.key === 'ArrowRight') { show(active + 1); start(); }
      });
      show(0);
      start();
    });
  };

  const initProducts = (scope = document) => {
    scope.querySelectorAll('[data-fe-product-carousel]').forEach((root) => {
      if (root.dataset.carouselReady === 'true') return;
      const track = root.querySelector('[data-fe-product-track]');
      const slides = Array.from(root.querySelectorAll('[data-fe-product-slide]'));
      const section = root.parentElement;
      const current = section.querySelector('[data-fe-product-current]');
      const total = section.querySelector('[data-fe-product-total]');
      const progress = section.querySelector('[data-fe-product-progress]');
      if (!track || !slides.length) return;
      root.dataset.carouselReady = 'true';
      if (total) total.textContent = String(slides.length).padStart(2, '0');
      let active = 0;
      let updateTimer;
      const render = () => {
        if (current) current.textContent = String(active + 1).padStart(2, '0');
        if (progress) progress.style.transform = `scaleX(${(active + 1) / slides.length})`;
      };
      const update = () => {
        const left = track.scrollLeft;
        active = slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - left) < Math.abs(slides[best].offsetLeft - left) ? i : best, 0);
        render();
      };
      const move = (direction) => {
        const target = Math.max(0, Math.min(slides.length - 1, active + direction));
        active = target;
        render();
        track.scrollTo({ left: slides[target].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      root.querySelector('[data-fe-product-prev]')?.addEventListener('click', () => move(-1));
      root.querySelector('[data-fe-product-next]')?.addEventListener('click', () => move(1));
      track.addEventListener('scroll', () => {
        window.requestAnimationFrame(update);
        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(update, 120);
      }, { passive: true });
      track.addEventListener('scrollend', update, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') move(-1);
        if (event.key === 'ArrowRight') move(1);
      });
      update();
    });
  };

  const init = (scope = document) => { initHero(scope); initProducts(scope); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

